import { Link } from 'react-router-dom';
import Navigation from '../../components/feature/Navigation';
import Footer from '../home/components/Footer';

export default function AddOnsPage() {
  const addOns = [
    {
      name: 'Global Visibility Boost™',
      price: '$499',
      description: 'Your app is positioned in multiple high-potential markets using our global indicators system.',
      icon: 'ri-global-fill',
      gradient: 'from-blue-600 to-cyan-600',
      features: [
        'Best-fit country mapping',
        'Visibility placement',
        'Exposure window',
        'Performance indicators'
      ]
    },
    {
      name: 'App Sale Readiness™',
      price: '$349',
      description: 'Shows whether your app is ready to attract buyers and what you need to strengthen.',
      icon: 'ri-money-dollar-circle-fill',
      gradient: 'from-emerald-600 to-teal-600',
      features: [
        'Resale indicator',
        'Buyer attraction score',
        'Key value gaps',
        'Priority improvements'
      ]
    },
    {
      name: 'Priority Delivery',
      price: '$199',
      description: 'Cuts your wait time significantly.',
      icon: 'ri-flashlight-fill',
      gradient: 'from-orange-600 to-red-600',
      features: [
        'Priority queue',
        'Faster turnaround',
        'Early confirmation updates'
      ]
    }
  ];

  return (
    <div className="min-h-screen bg-white">
      <Navigation />

      {/* Hero Section */}
      <section className="relative bg-gradient-to-br from-purple-600 via-pink-600 to-rose-600 text-white py-24">
        <div className="max-w-4xl mx-auto px-6 text-center">
          <h1 className="text-5xl md:text-6xl font-bold mb-6">
            Enhance Your Evaluation with Add-Ons
          </h1>
          <p className="text-xl md:text-2xl text-white/90">
            Optional upgrades designed to accelerate visibility, clarity, and opportunities.
          </p>
        </div>
      </section>

      {/* Add-Ons Grid */}
      <section className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-6">
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            {addOns.map((addOn, index) => (
              <div key={index} className="bg-white rounded-2xl shadow-xl overflow-hidden hover:shadow-2xl transition-all">
                {/* Header */}
                <div className={`bg-gradient-to-br ${addOn.gradient} text-white p-8`}>
                  <div className="w-16 h-16 flex items-center justify-center bg-white/20 backdrop-blur-sm rounded-xl mb-4">
                    <i className={`${addOn.icon} text-4xl`}></i>
                  </div>
                  <h3 className="text-2xl font-bold mb-2">{addOn.name}</h3>
                  <p className="text-4xl font-bold">{addOn.price}</p>
                </div>

                {/* Content */}
                <div className="p-8">
                  <p className="text-lg text-gray-600 mb-6">
                    {addOn.description}
                  </p>

                  <div className="mb-8">
                    <h4 className="text-sm font-semibold text-gray-900 mb-4 uppercase tracking-wide">
                      Includes:
                    </h4>
                    <ul className="space-y-3">
                      {addOn.features.map((feature, idx) => (
                        <li key={idx} className="flex items-start gap-3">
                          <i className="ri-checkbox-circle-fill text-xl text-teal-600 flex-shrink-0 mt-0.5"></i>
                          <span className="text-gray-700">{feature}</span>
                        </li>
                      ))}
                    </ul>
                  </div>

                  <Link
                    to="/pricing"
                    className={`block w-full text-center px-6 py-3 bg-gradient-to-r ${addOn.gradient} text-white rounded-lg font-semibold hover:opacity-90 transition-all whitespace-nowrap cursor-pointer`}
                  >
                    Add {addOn.name.split('™')[0]}
                  </Link>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Benefits Section */}
      <section className="py-20 bg-white">
        <div className="max-w-4xl mx-auto px-6">
          <h2 className="text-4xl font-bold text-center mb-16 text-gray-900">
            Why Add-Ons Make a Difference
          </h2>
          <div className="grid md:grid-cols-3 gap-8">
            {[
              {
                icon: 'ri-rocket-fill',
                title: 'Accelerate Results',
                description: 'Get faster insights and quicker market positioning'
              },
              {
                icon: 'ri-eye-fill',
                title: 'Increase Visibility',
                description: 'Reach more markets and potential users globally'
              },
              {
                icon: 'ri-line-chart-fill',
                title: 'Maximize Value',
                description: 'Understand your app\'s full potential and resale value'
              }
            ].map((benefit, index) => (
              <div key={index} className="text-center">
                <div className="w-16 h-16 flex items-center justify-center bg-gradient-to-br from-purple-100 to-pink-100 rounded-full mx-auto mb-4">
                  <i className={`${benefit.icon} text-3xl text-purple-600`}></i>
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-2">{benefit.title}</h3>
                <p className="text-gray-600">{benefit.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Final CTA */}
      <section className="py-20 bg-gradient-to-br from-gray-900 to-gray-800 text-white">
        <div className="max-w-4xl mx-auto px-6 text-center">
          <h2 className="text-4xl font-bold mb-8">
            Ready to Enhance Your App's Journey?
          </h2>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link
              to="/pricing"
              className="inline-flex items-center justify-center px-8 py-4 bg-white text-gray-900 rounded-lg font-semibold hover:bg-gray-100 transition-all whitespace-nowrap cursor-pointer"
            >
              Explore Tiers
            </Link>
            <Link
              to="/submit-app"
              className="inline-flex items-center justify-center px-8 py-4 bg-white/10 backdrop-blur-sm text-white border-2 border-white/30 rounded-lg font-semibold hover:bg-white/20 transition-all whitespace-nowrap cursor-pointer"
            >
              Submit Your App
            </Link>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
